import { logEvent } from './logGaEvent'

const logPriceWatchModalOpen = ({ tripType, isUserSignedIn }) => {
  logEvent('internal_link', {
    link_name: 'price_watch_click_tile',
    page_name: 'listings',
    product_name: 'air',
    link_item: tripType?.toLowerCase?.(),
    login: isUserSignedIn ? 'y' : 'n',
  })
}

const logPriceWatchSubscribe = ({ tripType, isUserSignedIn }) => {
  logEvent('internal_link', {
    link_name: 'price_watch_subscribe',
    page_name: 'listings',
    product_name: 'air',
    link_item: tripType?.toLowerCase?.(),
    login: isUserSignedIn ? 'y' : 'n',
  })
}

const logPriceWatchSubscribeDupe = ({ tripType, isUserSignedIn }) => {
  logEvent('internal_link', {
    link_name: 'price_watch_subscribe_dupe',
    page_name: 'listings',
    product_name: 'air',
    link_item: tripType?.toLowerCase?.(),
    login: isUserSignedIn ? 'y' : 'n',
  })
}

const logPriceWatchUnsubscribe = ({ tripType, isUserSignedIn }) => {
  logEvent('internal_link', {
    link_name: 'price_watch_unsubscribe',
    page_name: 'listings',
    product_name: 'air',
    link_item: tripType?.toLowerCase?.(),
    login: isUserSignedIn ? 'y' : 'n',
  })
}

const logPriceWatchUnsubscribeDupe = ({ tripType, isUserSignedIn }) => {
  logEvent('internal_link', {
    link_name: 'price_watch_unsubscribe_dupe',
    page_name: 'listings',
    product_name: 'air',
    link_item: tripType?.toLowerCase?.(),
    login: isUserSignedIn ? 'y' : 'n',
  })
}

const logPriceWatchHandoffDrawerOpen = ({ tripType, isUserSignedIn, isOpen }) => {
  logEvent('internal_link', {
    link_name: isOpen ? 'price_watch_handoff_open' : 'price_watch_handoff_close',
    page_name: 'listings',
    product_name: 'air',
    link_item: tripType?.toLowerCase?.(),
    login: isUserSignedIn ? 'y' : 'n',
  })
}

const logPriceWatchGetAppClick = ({ tripType, isUserSignedIn }) => {
  logEvent('internal_link', {
    link_name: 'price_watch_get_the_app',
    page_name: 'listings',
    product_name: 'air',
    link_item: tripType?.toLowerCase?.(),
    login: isUserSignedIn ? 'y' : 'n',
  })
}

export {
  logPriceWatchModalOpen,
  logPriceWatchSubscribe,
  logPriceWatchSubscribeDupe,
  logPriceWatchUnsubscribe,
  logPriceWatchUnsubscribeDupe,
  logPriceWatchHandoffDrawerOpen,
  logPriceWatchGetAppClick,
}
